"use strict";
//import { manualDispatchActions } from '../store/HistoricalData';
//import { actionCreators as sourceFeedbackActionCreators } from '../store/SourceFeedbackStore';
//import { actionCreators as sourceCommunicationActionCreators } from '../store/SourceCommunicationStore';

let signalR = require("@aspnet/signalr");
var he = require('he');

let connection = new signalR.HubConnectionBuilder().withUrl("/notificationHub").build();


//connection.on("CaseTrackingServiceCompleted", function (data) {
//    console.log(data);
//});

//connection.on("ReceiveUpdatedHistoricalData", function (data) {
//    console.log(data);
//});

//connection.on("ReceiveSourceFeedbackMessages", function (data) {
//    sourceFeedbackActionCreators.requestSourceFeedbackUpdate(window.store.dispatch, data);
//});

//connection.on("ReceiveSourceCommunicationMessages", function (data, updateOrDelete) {
//    sourceCommunicationActionCreators.requestSourceCommunicationUpdate(window.store.dispatch, data, updateOrDelete);
//});


//connection.on("ModifiedSourceUpdateInterval", function (ossId, courtUid, updateInterval) {
//    manualDispatchActions.updateSourceInterval(window.store.dispatch, ossId, courtUid, updateInterval);
//});

let afterConnectionStarts = (connection) => {
    connection.then(function () {
    // read from local storage

    // set user settings on server
    let userSettings = JSON.parse(localStorage.getItem('userSettings'));
    connection.then(c => c.invoke("SetUserSettings", userSettings));

    // set subscriptions on server
    let ossIdSubs = JSON.parse(localStorage.getItem('ossIdSubs'));
    if (!ossIdSubs || !ossIdSubs.filter)
        return;
    let ossIds = Object.keys(ossIdSubs).filter(key => ossIdSubs[key]['historical']);

    if (ossIds.length > 0) {
        console.log(`startup: subscribing to ${ossIds}`);
        connection.then(c => c.invoke("Subscribe", "historical", { ossIds: ossIds }));
    }

}).catch(function (err) {
    return console.error(err.toString());
});
}

//afterConnectionStarts(connection.start());

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


connection.connection.onclose(async () => {
    await sleep(5000);

    connection.start();
});

var connectionPromise = connection.start().then(function () {
    // read from local storage

    // set user settings on server
    let userSettings = JSON.parse(localStorage.getItem('userSettings'));
    connection.invoke("SetUserSettings", userSettings);

    // set subscriptions on server
    let ossIdSubs = JSON.parse(localStorage.getItem('ossIdSubs'));
    if (!ossIdSubs || !ossIdSubs.filter)
        return connection;
    let ossIds = Object.keys(ossIdSubs).filter(key => ossIdSubs[key]['historical']);

    if (ossIds.length > 0) {
        console.log(`startup: subscribing to ${ossIds}`);
        connection.invoke("Subscribe", "historical", { ossIds: ossIds });
    }
    return connection;
});
//    .catch(function (err) {
//    console.log(err);
//    return connection;
//});

//connection.connection.onclose(function () {
//    setTimeout(function () {
//        afterConnectionStarts(connection.start());
//    }, 5000); // Restart connection after 5 seconds.
//});
export default connectionPromise;